import axios from "axios";
import debounce from "lodash.debounce";
import React from "react";
import {
  IGetGameRequest,
  IGameData,
  IDailyCheckInResult,
  IDailyCheckInRequest,
  IDailyCheckInHistory,
  IDailyCheckInHistoryResult,
} from "../interface/Interface";
import { v4 as uuidv4 } from "uuid";
import Cookies from "js-cookie";

const useWindowSize = () => {
  const [size, setSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    const handleResize = debounce(() => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }, 50);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return size;
};

export const IsMobile = (): boolean => {
  return useWindowSize().width > 768 ? false : true;
};

///取得遊戲樣板
export const GetDailyCheckInGameData = async (
  request: IGetGameRequest
): Promise<IGameData | null> => {
  const url =
    process.env.REACT_APP_API_DOMAIN +
    "/api/DailyCheckIn/GetDailyCheckInGameData";

  try {
    const response = await axios.post<IGameData>(url, request, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.log("Response Error:", error.response.data);
      } else if (error.request) {
        console.log(error);
      } else {
        console.log("Error:", error.message);
      }
    } else {
      console.log("Non-Axios Error:", error);
    }
  }

  return null;
};

///確認是否有登入
export const CheckInData = async (redirectUrl: string): Promise<void> => {
  //// 預覽或 WYSIWYG 時不做 CheckIn 檢查
  const isPreview =
    new URLSearchParams(window.location.search).get("preview") === "true";

  const isWYSIWYG =
    new URLSearchParams(window.location.search).get("wysiwyg") === "true";

  if (isPreview || isWYSIWYG) {
    return;
  }

  const gameId = new URLSearchParams(window.location.search).get("gameid");
  
  const memberCode = GetMemberCodeFromQueryString();

  if (gameId == undefined || memberCode == undefined) {
    return;
  }

  var guid = Cookies.get("guidData");

  if (guid === undefined || guid === "") {
    guid = uuidv4();
    Cookies.set("guidData", guid);
  }

  const url =
    process.env.REACT_APP_API_DOMAIN +
    `/api/CheckIn/${gameId}/${memberCode}/${guid}`;

  try {
    const res = await axios.get(url, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    if (res.status === 200) {
      return;
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response && error.response.status === 400) {
        window.location.href = redirectUrl;
      } else {
      }
    }
  }
};

/// 每日簽到
export const DailyCheckIn = async (
  request: IDailyCheckInRequest
): Promise<IDailyCheckInResult> => {
  const url =
    process.env.REACT_APP_API_DOMAIN + "/API/DailyCheckIn/DailyCheckIn";

  try {
    const response = await axios.post<IDailyCheckInResult>(url, request, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // 服务器返回了状态码，表示请求已到达服务器
        console.log("Response Error:", error.response.data);
      } else if (error.request) {
        // 请求已发送，但未收到响应
        console.log(error);
      } else {
        // 其他错误
        console.log("Error:", error.message);
      }
    } else {
      // 非 Axios 错误
      console.log("Non-Axios Error:", error);
    }

    return {} as IDailyCheckInResult;
  }
};

/// 每日簽到
export const GetDailyCheckInHistory = async (
  request: IDailyCheckInRequest
): Promise<IDailyCheckInHistoryResult> => {
  const url =
    process.env.REACT_APP_API_DOMAIN +
    "/API/DailyCheckIn/GetDailyCheckInHistory";

  try {
    const response = await axios.post<IDailyCheckInHistoryResult>(
      url,
      request,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // 服务器返回了状态码，表示请求已到达服务器
        console.log("Response Error:", error.response.data);
      } else if (error.request) {
        // 请求已发送，但未收到响应
        console.log(error);
      } else {
        // 其他错误
        console.log("Error:", error.message);
      }
    } else {
      // 非 Axios 错误
      console.log("Non-Axios Error:", error);
    }

    return { message: "", list: [] } as IDailyCheckInHistoryResult;
  }
};

export const GetMemberCodeFromQueryString = (): string | null => {
  const memberCode = new URLSearchParams(window.location.search).get(
    "Membercode"
  );

  if (memberCode == null) {
    return null;
  }

  return atob(memberCode.substring(0, memberCode.length - 8));
};
